import { IIdObject } from '@common/interfaces/id-object.interface';
import { IBoxCustomisationProduce } from '../pack-house-generated-api';

// product catalog for boxes
export interface IBoxCustomisationProduceDto extends Omit<IBoxCustomisationProduce, 'id' | 'name'>, IIdObject {
    id: string;
}

export const createBoxCustomisationProduceDto = (data: IBoxCustomisationProduce): IBoxCustomisationProduceDto => {
    return {
        ...data,
        id: data?.code || '',
    };
};
